module.exports = __webpack_public_path__ + "static/media/sun-mobility.5217351c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sun-mobility.jpg
// module id = 311
// module chunks = 0